import { Component, useContext } from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { MBView } from '@shared/components/MBView';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBBoxedIcon, MBImageURISource } from '@shared/components/image';
import { MBNotificationBadge } from '@shared/components/notificationBadge';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { ColorThemeContext } from '@shared/styles';

interface Props {
  icon?: MBImageURISource;
  title?: string;
  unreadCount?: number;
  style?: StyleProp<ViewStyle>;
  onPress?(node: Component): void;
  anchorName?: string;
  testID?: string;
}

export function MBNavigationHeaderButton({
  icon,
  title,
  unreadCount,
  style,
  onPress,
  anchorName,
  testID,
}: Props) {
  const colors = useContext(ColorThemeContext);
  return (
    <MBView paddingHorizontal={1} style={style}>
      <View style={{ anchorName }}>
        <MBTouchableOpacity onPress={onPress} testID={testID}>
          {!!icon && <MBBoxedIcon color={colors.foregroundActive} source={icon} />}
          {!!title && <Text size="subtitle">{title}</Text>}
          {!!unreadCount && (
            <MBNotificationBadge
              style={{
                position: 'absolute',
                top: 0,
                right: 0,
              }}
              count={unreadCount}
            />
          )}
        </MBTouchableOpacity>
      </View>
    </MBView>
  );
}
